<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 9.8a1 1 0 00-1 1v4.79l-2.31 2.3a1 1 0 000 1.42 1 1 0 001.42 0l2.6-2.6A1 1 0 0017 16v-5.2a1 1 0 00-1-1z"/><path d="M16 3a13 13 0 1013 13A13 13 0 0016 3zm1 24v-1a1 1 0 00-2 0v1a11 11 0 01-9.95-10H6a1 1 0 000-2H5a11 11 0 0110-9.95V6a1 1 0 002 0V5a11 11 0 0110 10h-1a1 1 0 000 2h1a11 11 0 01-10 10z"/></svg>